<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">
      <form class="login100-form">
        <div class="form-content">
          <span class="error-header p-b-45">
            404
          </span>
          <span class="error-subheader p-b-5">
            Aceasta pagina nu exista
          </span>
          <span class="error-subheader2 p-b-5">
            Probabil ati accesat un link sau modul inexistent
          </span>
          <div class="container-login100-form-btn p-t-30	">
            <button mat-flat-button color="primary" class="login100-form-btn" (click)="goHome()">
              Acasa
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<app-accessibility></app-accessibility>